<template>
  <div class="handcopy-audit">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>手抄报审核</span>
          <el-radio-group v-model="auditStatus" @change="handleStatusChange">
            <el-radio-button value="0">待审核</el-radio-button>
            <el-radio-button value="1">已通过</el-radio-button>
            <el-radio-button value="2">已拒绝</el-radio-button>
          </el-radio-group>
        </div>
      </template>
      
      <el-table :data="auditList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="category_name" label="分类" />
        <el-table-column prop="author" label="作者" />
        <el-table-column label="图片" width="120">
          <template #default="{ row }">
            <el-image 
              :src="row.image_url" 
              style="width: 80px; height: 80px"
              fit="cover"
              :preview-src-list="[row.image_url]"
            />
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="提交时间" />
        <el-table-column label="操作" width="200" v-if="auditStatus === '0'">
          <template #default="{ row }">
            <el-button type="success" size="small" @click="handlePass(row)">通过</el-button>
            <el-button type="danger" size="small" @click="handleReject(row)">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        v-model:current-page="page"
        v-model:page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        style="margin-top: 20px"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import request from '../../utils/request'

export default {
  name: 'HandCopyAudit',
  setup() {
    const auditList = ref([])
    const loading = ref(false)
    const page = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const auditStatus = ref('0')
    
    const fetchList = async () => {
      loading.value = true
      try {
        const res = await request.get('/api/admin/hand-copy', {
          params: { 
            page: page.value, 
            limit: pageSize.value, 
            status: auditStatus.value 
          }
        })
        auditList.value = res.data || []
        total.value = res.total || 0
      } catch (error) {
        ElMessage.error('获取列表失败')
      } finally {
        loading.value = false
      }
    }
    
    const handleStatusChange = () => {
      page.value = 1
      fetchList()
    }
    
    const handlePageChange = (val) => {
      page.value = val
      fetchList()
    }
    
    const handlePass = async (row) => {
      try {
        await request.put(`/api/admin/hand-copy/${row.id}`, {
          status: 1
        })
        ElMessage.success('审核通过')
        fetchList()
      } catch (error) {
        ElMessage.error('操作失败')
      }
    }
    
    const handleReject = async (row) => {
      try {
        const { value: reason } = await ElMessageBox.prompt('请输入拒绝原因', '拒绝原因', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          inputValidator: (value) => {
            if (!value) return '请输入拒绝原因'
            return true
          }
        })
        
        await request.put(`/api/admin/hand-copy/${row.id}`, {
          status: 2,
          reject_reason: reason
        })
        ElMessage.success('已拒绝')
        fetchList()
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('操作失败')
        }
      }
    }
    
    onMounted(() => {
      fetchList()
    })
    
    return {
      auditList,
      loading,
      page,
      pageSize,
      total,
      auditStatus,
      handleStatusChange,
      handlePageChange,
      handlePass,
      handleReject
    }
  }
}
</script>

<style scoped>
.handcopy-audit {
  padding: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  flex-wrap: wrap;
  gap: 12px;
}

.card-header span {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

/* 审核图片 */
:deep(.el-image) {
  border-radius: 8px;
  overflow: hidden;
}
</style>
